import React = require("react");
import { LimaIconProps } from "./DefLimaIconType";

export const LimaIconSaveActa = ({
  size = 32, // or any default size of your choice
  color = "black", // or any color of your choice
  fillColor = "black", // or any color of your choice
  title = "", //title
}: LimaIconProps): JSX.Element => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    //   width={size} // added size here
    //   height={size} // added size here
    //   fill={color} // added color here
    //   aria-labelledby="title"
    // >
    //   <title id="title">{title}</title>
    //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
    //   <path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z" />
    // </svg>

    <svg
      viewBox="0 0 210 297"
      xmlns="http://www.w3.org/2000/svg"
      width={size} // added size here
      height={size} // added size here
      fill={fillColor} // added color here
      aria-labelledby="title"
    >
      <title id="title">{title}</title>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          style={{
            display: "inline",
            fill: "none",
            stroke: color,
            strokeWidth: 14,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="m243.471 129.737 131.928-.32a8.487 8.487 134.93 0 0 8.466-8.487V25.407a20.293 20.293 67.353 0 0-6.017-14.423l-23.288-23.05a20.59 20.59 22.353 0 0-14.484-5.956h-96.604a8.467 8.467 135 0 0-8.467 8.467V121.29a8.446 8.446 44.93 0 0 8.466 8.446z"
        />
        <path
          style={{
            fill: "none",
            stroke: color,
            strokeWidth: 10,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="M273.572-11.174v26.496a8.467 8.467 45 0 0 8.466 8.467H328.9a8.467 8.467 135 0 0 8.467-8.467v-26.856M263.21 124.354V69.136a7.387 7.387 135.081 0 1 7.408-7.387l78.582.222a7.43 7.43 45.081 0 1 7.408 7.43v56.011"
        />
        <path
          style={{
            display: "inline",
            fill: "none",
            stroke: color,
            strokeWidth: 13.9355,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="M162.402 93.87V42.945L127.477 7.911H15.217v148.088l76.293-.187"
        />
        <path
          style={{
            fill: "none",
            stroke: color,
            strokeWidth: 10,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="M46.83 13.791v26.496a8.467 8.467 45 0 0 8.466 8.467h46.861a8.467 8.467 135 0 0 8.467-8.467V13.431"
        />
        <path
          style={{
            fill: "none",
            stroke: color,
            strokeWidth: 9.40969,
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="M41.344 150.302v-54.59c0-4.677 3.79-8.48 8.466-8.491 37.479-.088 56.087.123 65.208.258 4.67.07 8.458 2.711 8.458 6.016"
        />
      </g>
      <g
        style={{
          display: "inline",
        }}
      >
        <path
          d="M167.865 180.105c0 1.672-1.336 3.029-2.984 3.029h-50.236c-1.645 0-2.985-1.357-2.985-3.03v-64.616c0-1.673 1.34-3.032 2.985-3.032h25.035v21.876c0 3.72 2.97 6.731 6.632 6.731l21.553-.003zm-23.211-65.89 10.74 10.899 10.74 10.898-19.822.003c-.597 0-.992-.307-1.174-.492a1.705 1.705 0 0 1-.484-1.191zm25.854 19.1-23.192-23.538c-.228-.232-.49-.418-.739-.616-.982-.784-2.109-1.346-3.33-1.596a7.773 7.773 0 0 0-1.561-.158h-27.041c-4.394 0-7.959 3.618-7.959 8.081v64.617c0 4.463 3.565 8.077 7.959 8.077h50.236c4.397 0 7.958-3.614 7.958-8.077v-41.078a8.137 8.137 0 0 0-2.331-5.711z"
          style={{
            // fill: "#212121",
            fill: color,
            fillRule: "nonzero",
            stroke: "none",
            strokeWidth: 10,
            strokeMiterlimit: 4,
            strokeDasharray: "none",
          }}
        />
      </g>
    </svg>
  );
};
